<template>
  <van-popup
    :value="show"
    @close="close"
    @click-overlay="close"
    @click-close-icon="close"
    position="bottom"
    class="popup"
  >
    <div class="popup-wrap">
      <van-icon name="cross" color="#CCCCCC" class="icon" @click="close" />
      <div class="title">{{ titleText }}</div>
      <div class="desc">当前享有多重特权，退款无忧</div>
      <div class="benefit-list">
        <div
          class="benefit-item"
          v-for="item in jyCardInfo.benefit_info_list"
          :key="item.id"
        >
          <div class="benefit-item-title">{{ item.show_title }}</div>
          <div class="benefit-item-value">{{ item.desc }}</div>
        </div>
      </div>
      <div class="content-desc">{{ descText }}</div>
      <div class="btn" @click="close">立即领取</div>
      <div class="text-btn" @click="handleCancelDeduction">{{ btnText }}</div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import Vue from "vue";

import { useStore } from "@/components/use/base";
import { fetchRefund, cancelDeduction } from "@/apis/jiayin";

const vm = Vue.prototype;

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    canCancelDeduction: {
      type: Boolean,
      default: false,
    },
    canRefund: {
      type: Boolean,
      default: false,
    },
    jyCardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const close = () => {
      emit("close", false);
    };

    const titleText = computed(() => {
      if (props.canRefund) return "退费管理";
      if (props.canCancelDeduction) return "扣费管理";
    });

    const descText = computed(() => {
      if (props.canRefund)
        return "该权益费用预计会在1～3个工作日内原路返回，退费成功后会短信通知您，请注意查收";
      if (props.canCancelDeduction)
        return `下次续费时间：${store.state?.userInfo?.card_expiry_date?.[0]}`;
    });

    const btnText = computed(() => {
      if (props.canRefund) return "确定申请退费";
      if (props.canCancelDeduction) return "确定取消扣费";
    });

    const handleCancelDeduction = async () => {
      if (props.canCancelDeduction) {
        const { data } = await cancelDeduction({
          orderId: store.state.orderId,
        });
        if (data.isSuccess) {
          vm.$toast("取消扣费已申请成功，感谢您的使⽤～");
          await store.dispatch("fetchUserInfo");
          emit("refresh");
          close();
        }
      }
      if (props.canRefund) {
        const { data } = await fetchRefund({
          orderId: store.state.orderId,
        });
        if (data.refundable) {
          vm.$toast("申请退费已提交，感谢您的使用～");
          await store.dispatch("fetchUserInfo");
          emit("refresh");
          close();
        }
      }
    };

    return {
      close,
      handleCancelDeduction,
      titleText,
      descText,
      btnText,
    };
  },
});
</script>

<style scoped lang="less">
.popup {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.popup-wrap {
  height: 425px;
  background: #fff;
  position: relative;
  padding-top: 43px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  .title {
    height: 28px;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
  }

  .desc {
    margin-top: 7px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
  }

  .benefit-list {
    margin-top: 16px;

    display: flex;
    flex-wrap: wrap;
    gap: 5px;

    .benefit-item {
      width: 109px;
      height: 67px;
      background: #fff7f2;
      border-radius: 8px;
      border: 1px solid #fcc2c2;
      box-sizing: border-box;
      padding: 12px 10px;
    }

    .benefit-item-title {
      font-weight: 600;
      font-size: 14px;
      color: #ff8035;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .benefit-item-value {
      font-weight: 400;
      font-size: 10px;
      color: #666666;
      line-height: 12px;
      margin-top: 4px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .content-desc {
    margin-top: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
  }

  .btn {
    margin-top: 28px;
    background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
    height: 40px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 17px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }

  .text-btn {
    margin-top: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }
}

.icon {
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  right: 16px;
  top: 16px;
}
</style>
